module.exports = __webpack_public_path__ + "static/media/67.617e00a0.png";